import Dexie, { type EntityTable } from 'dexie';
import type { Settings } from '@/store/settingsModel';
import type { Workout } from '@/workouts/model';
import type { PlannedRide } from '@/plan/model';
import type { ProcessedRoute } from '@/routes/model';
import type { ActiveRideSnapshot, RideRecord, RideSample } from '@/ride/model';

export interface SettingsRow {
  key: 'settings';
  value: Settings;
}

export interface RideDataRow {
  rideId: string;
  samples: RideSample[];
  fit?: Uint8Array;
}

export interface ElevationCacheRow {
  hash: string;
  elevations: number[];
  createdAt: number;
}

export interface KvRow {
  key: string;
  value: unknown;
}

/** Local-first storage (SPEC §13). */
export class VeloStubeDB extends Dexie {
  settings!: EntityTable<SettingsRow, 'key'>;
  workouts!: EntityTable<Workout, 'id'>;
  plans!: EntityTable<PlannedRide, 'id'>;
  routes!: EntityTable<ProcessedRoute, 'id'>;
  rides!: EntityTable<RideRecord, 'id'>;
  rideData!: EntityTable<RideDataRow, 'rideId'>;
  activeRide!: EntityTable<ActiveRideSnapshot, 'key'>;
  elevationCache!: EntityTable<ElevationCacheRow, 'hash'>;
  kv!: EntityTable<KvRow, 'key'>;

  constructor(name = 'velostube') {
    super(name);
    this.version(1).stores({
      settings: 'key',
      workouts: 'id, updatedAt',
      plans: 'id, date, workoutId, updatedAt',
      routes: 'id, updatedAt',
      rides: 'id, startedAt, updatedAt',
      rideData: 'rideId',
      activeRide: 'key',
      elevationCache: 'hash',
      kv: 'key',
    });
  }
}

export const db = new VeloStubeDB();
